import ajax from '@/api/ajax'
import _ from 'lodash'
import { COUNTRY_CODE } from '@uip-alpha/business-constants'

const mixCitySelector = {
    data() {
        return {
            selectedProvince: {}, // 选择的省会
            selectedCity: {}, // 选择的城市
            selectedCountry: {}, // 选择的区域
            areaData: {
                provinces: [], // 省会列表
                cities: [], // 城市列表
                countries: [] // 区域列表
            },
            selectedAreaType: '' // 当前选择的区域状态
        }
    },
    methods: {
        initCitySelector({ code = COUNTRY_CODE.MAINLAND, province, city, country }) {
            // 初始化省会信息
            this.getRegion({ code }).then(provinces => {
                this.areaData = { ...this.areaData, provinces }
                this.initAreaByNames({ province, city, country })
            })
        },
        async getRegion({ code }) {
            this.$loading('加载中')
            const { data } = await ajax.getRegions({
                lang: 'sc',
                regiion: 'cn',
                translate: 'sc',
                data: {
                    code
                }
            })
            this.$loading()
            const result = this.filterData(data)
            return result
        },
        async initAreaByNames({ province, city, country }) {
            const provinces = this.areaData.provinces
            if (!provinces) {
                return
            }
            if (province) {
                // 初始化城市信息
                this.selectedProvince = this.areaData.provinces.filter(item => item.name === province)[0] || {}
                const cities = await this.getRegion({
                    code: this.selectedProvince.code
                })
                if (cities.length <= 0) {
                    return
                }
                this.areaData = { ...this.areaData, cities }
            }
            if (city) {
                // 初始化县区信息
                this.selectedCity = this.areaData.cities.filter(item => item.name === city)[0] || {}
                const countries = await this.getRegion({
                    code: this.selectedCity.code
                })
                this.areaData = { ...this.areaData, countries }
            }
            if (country) {
                this.selectedCountry = this.areaData.countries.filter(item => item.name === country)[0] || {}
            }
        },
        filterData(lst) {
            const result = []
            if (Array.isArray(lst)) {
                const ids = new Set()
                _(lst).forEach(item => {
                    if (!ids.has(item.id)) {
                        result.push(item)
                        ids.add(item.id)
                    }
                })
            }
            return result
        }
    },
    watch: {
        async selectedProvince(newVal, oldVal) {
            // 加载城市信息
            const cities = await this.getRegion({
                code: newVal.code
            })
            if (cities.length > 0) {
                this.areaData = { ...this.areaData, cities }
                this.selectedAreaType = 'city'
            }
        },
        async selectedCity(newVal, oldVal) {
            // 加载县区信息
            const countries = await this.getRegion({
                code: newVal.code
            })
            if (countries.length > 0) {
                this.areaData = { ...this.areaData, countries }
                this.selectedAreaType = 'country'
            }
        }
    },
    created() {
        this.selectedAreaType = 'province'
    }
}
export default mixCitySelector



// WEBPACK FOOTER //
// ./src/components/citySelector/mixin.js